import { useState } from "preact/hooks";

import * as validators from "../validators";

function isValid(formData, key, validations) {
  const value = formData[key];
  return validations.reduce((result, validator) => {
    if (result === true) {
      if (typeof validator === "function") {
        return validator(value, formData);
      }
      return validators[validator](value);
    }
    return result;
  }, true);
}

export function createFormData(form, initialData) {
  const [formData, setFormData] = useState(
    Object.keys(form).reduce(
      (result, key) => ({
        ...result,
        [key]: (initialData && initialData[key]) || "",
      }),
      {}
    )
  );
  const [errors, setErrors] = useState({});
  const [valid, setValid] = useState(true);
  const [changed, setChanged] = useState(false);

  function updateFormData(key, value) {
    const data = {
      ...formData,
      [key]: value,
    };
    setFormData(data);
    return data;
  }

  function updateErrors(key, value) {
    const newErrors = {
      ...errors,
      [key]: value,
    };
    setErrors(newErrors);
    setValid(Object.values(newErrors).every((error) => error === true));
  }

  function handleInput(key, value) {
    const newFormData = updateFormData(key, value);
    updateErrors(key, isValid(newFormData, key, form[key].validations));
    setChanged(true);
  }

  function handleBlur(key) {
    updateErrors(key, isValid(formData, key, form[key].validations));
  }

  function fieldsFor(key, options = {}) {
    let error = null;
    error =
      (options.serverErrors && options.serverErrors[0]) ||
      (errors[key] === true ? null : errors[key]);

    return {
      name: key,
      onInput: (event) => {
        const value =
          (event && event.target && event.target.value !== undefined
            ? event.target.value
            : event) || "";
        handleInput(key, value);
        options.onInput && options.onInput(value);
      },
      onBlur: (event) => {
        handleBlur(key);
      },
      value: formData[key],
      error,
    };
  }

  function validate(touchOnFail = false) {
    const errors = Object.keys(form).reduce(
      (memo, key) => ({
        ...memo,
        [key]: isValid(formData, key, form[key].validations),
      }),
      {}
    );
    setErrors(errors);
    const valid = Object.values(errors).every((error) => error === true);
    setValid(valid);
    return valid;
  }

  function onSubmit(handleSubmit) {
    return function (event) {
      event.preventDefault();
      if (validate(true)) {
        handleSubmit(formData);
      }
    };
  }

  function setFormDataValue(key, value) {
    handleInput(key, value);
  }

  function teaseValidation() {
    const errors = Object.keys(form).reduce(
      (memo, key) => ({
        ...memo,
        [key]: isValid(formData, key, form[key].validations),
      }),
      {}
    );
    return Object.values(errors).every((error) => error === true);
  }

  return {
    formData,
    setFormDataValue,
    handleInput,
    errors,
    onSubmit,
    valid,
    validate,
    teaseValidation,
    fieldsFor,
    changed,
  };
}
